"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardingApi = void 0;
var runtime = __importStar(require("../runtime"));
var CreateVisitorDto_1 = require("../models/CreateVisitorDto");
var CreateVisitorResponseDto_1 = require("../models/CreateVisitorResponseDto");
var DigestPreferencesEditorResponseDto_1 = require("../models/DigestPreferencesEditorResponseDto");
var ManageDigestResponseDto_1 = require("../models/ManageDigestResponseDto");
var PatchDigestPreferencesDto_1 = require("../models/PatchDigestPreferencesDto");
var PatchDigestPreferencesResponseDto_1 = require("../models/PatchDigestPreferencesResponseDto");
var PatchDigestSportVisibilityDto_1 = require("../models/PatchDigestSportVisibilityDto");
var PatchDigestSportVisibilityResponseDto_1 = require("../models/PatchDigestSportVisibilityResponseDto");
var PatchDigestStepDto_1 = require("../models/PatchDigestStepDto");
var PatchDigestStepResponseDto_1 = require("../models/PatchDigestStepResponseDto");
var PostSportDigestResponseDto_1 = require("../models/PostSportDigestResponseDto");
var RemoveDigestSportResponseDto_1 = require("../models/RemoveDigestSportResponseDto");
var SportQuestionsResponseDto_1 = require("../models/SportQuestionsResponseDto");
var SportResponseDto_1 = require("../models/SportResponseDto");
var SubmitDigestPreferencesDto_1 = require("../models/SubmitDigestPreferencesDto");
var SubmitDigestPreferencesResponseDto_1 = require("../models/SubmitDigestPreferencesResponseDto");
var UpdateVisitorStepDto_1 = require("../models/UpdateVisitorStepDto");
var VisitorSessionResponseDto_1 = require("../models/VisitorSessionResponseDto");
/**
 *
 */
var OnboardingApi = /** @class */ (function (_super) {
    __extends(OnboardingApi, _super);
    function OnboardingApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creates request options for onboardingControllerCreateVisitorV1 without sending the request
     */
    OnboardingApi.prototype.onboardingControllerCreateVisitorV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                if (requestParameters['createVisitorDto'] == null) {
                    throw new runtime.RequiredError('createVisitorDto', 'Required parameter "createVisitorDto" was null or undefined when calling onboardingControllerCreateVisitorV1().');
                }
                queryParameters = {};
                headerParameters = {};
                headerParameters['Content-Type'] = 'application/json';
                urlPath = "/v1/onboarding/visitors";
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'POST',
                        headers: headerParameters,
                        query: queryParameters,
                        body: (0, CreateVisitorDto_1.CreateVisitorDtoToJSON)(requestParameters['createVisitorDto']),
                    }];
            });
        });
    };
    /**
     * Create a pre-auth onboarding visitor session
     */
    OnboardingApi.prototype.onboardingControllerCreateVisitorV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.onboardingControllerCreateVisitorV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, CreateVisitorResponseDto_1.CreateVisitorResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create a pre-auth onboarding visitor session
     */
    OnboardingApi.prototype.onboardingControllerCreateVisitorV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.onboardingControllerCreateVisitorV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for onboardingControllerGetMyDigestPreferencesEditorV1 without sending the request
     */
    OnboardingApi.prototype.onboardingControllerGetMyDigestPreferencesEditorV1RequestOpts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                queryParameters = {};
                headerParameters = {};
                urlPath = "/v1/onboarding/digest-preferences/me/editor";
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'GET',
                        headers: headerParameters,
                        query: queryParameters,
                    }];
            });
        });
    };
    /**
     * Get digest preferences editor state for add-more sports flow
     */
    OnboardingApi.prototype.onboardingControllerGetMyDigestPreferencesEditorV1Raw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.onboardingControllerGetMyDigestPreferencesEditorV1RequestOpts()];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, DigestPreferencesEditorResponseDto_1.DigestPreferencesEditorResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get digest preferences editor state for add-more sports flow
     */
    OnboardingApi.prototype.onboardingControllerGetMyDigestPreferencesEditorV1 = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.onboardingControllerGetMyDigestPreferencesEditorV1Raw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for onboardingControllerGetMyDigestPreferencesV1 without sending the request
     */
    OnboardingApi.prototype.onboardingControllerGetMyDigestPreferencesV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                queryParameters = {};
                headerParameters = {};
                if (requestParameters['acceptLanguage'] != null) {
                    headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
                }
                if (requestParameters['xLanguage'] != null) {
                    headerParameters['X-Language'] = String(requestParameters['xLanguage']);
                }
                urlPath = "/v1/onboarding/digest-preferences/me";
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'GET',
                        headers: headerParameters,
                        query: queryParameters,
                    }];
            });
        });
    };
    /**
     * Get saved digest preferences for manage digest screen
     */
    OnboardingApi.prototype.onboardingControllerGetMyDigestPreferencesV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.onboardingControllerGetMyDigestPreferencesV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, ManageDigestResponseDto_1.ManageDigestResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get saved digest preferences for manage digest screen
     */
    OnboardingApi.prototype.onboardingControllerGetMyDigestPreferencesV1 = function () {
        return __awaiter(this, arguments, void 0, function (requestParameters, initOverrides) {
            var response;
            if (requestParameters === void 0) { requestParameters = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.onboardingControllerGetMyDigestPreferencesV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for onboardingControllerGetPostSportDigestFlowV1 without sending the request
     */
    OnboardingApi.prototype.onboardingControllerGetPostSportDigestFlowV1RequestOpts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                queryParameters = {};
                headerParameters = {};
                urlPath = "/v1/onboarding/digest-flow/post-sport";
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'GET',
                        headers: headerParameters,
                        query: queryParameters,
                    }];
            });
        });
    };
    /**
     * Get post-sport digest steps (streaming platforms + digest time)
     */
    OnboardingApi.prototype.onboardingControllerGetPostSportDigestFlowV1Raw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.onboardingControllerGetPostSportDigestFlowV1RequestOpts()];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, PostSportDigestResponseDto_1.PostSportDigestResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get post-sport digest steps (streaming platforms + digest time)
     */
    OnboardingApi.prototype.onboardingControllerGetPostSportDigestFlowV1 = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.onboardingControllerGetPostSportDigestFlowV1Raw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for onboardingControllerGetQuestionsBySportV1 without sending the request
     */
    OnboardingApi.prototype.onboardingControllerGetQuestionsBySportV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                if (requestParameters['sport'] == null) {
                    throw new runtime.RequiredError('sport', 'Required parameter "sport" was null or undefined when calling onboardingControllerGetQuestionsBySportV1().');
                }
                queryParameters = {};
                headerParameters = {};
                if (requestParameters['acceptLanguage'] != null) {
                    headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
                }
                if (requestParameters['xLanguage'] != null) {
                    headerParameters['X-Language'] = String(requestParameters['xLanguage']);
                }
                urlPath = "/v1/onboarding/questions/{sport}";
                urlPath = urlPath.replace('{sport}', encodeURIComponent(String(requestParameters['sport'])));
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'GET',
                        headers: headerParameters,
                        query: queryParameters,
                    }];
            });
        });
    };
    /**
     * Get onboarding questions for a sport
     */
    OnboardingApi.prototype.onboardingControllerGetQuestionsBySportV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.onboardingControllerGetQuestionsBySportV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, SportQuestionsResponseDto_1.SportQuestionsResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get onboarding questions for a sport
     */
    OnboardingApi.prototype.onboardingControllerGetQuestionsBySportV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.onboardingControllerGetQuestionsBySportV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for onboardingControllerGetVisitorSessionV1 without sending the request
     */
    OnboardingApi.prototype.onboardingControllerGetVisitorSessionV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                if (requestParameters['xVisitorId'] == null) {
                    throw new runtime.RequiredError('xVisitorId', 'Required parameter "xVisitorId" was null or undefined when calling onboardingControllerGetVisitorSessionV1().');
                }
                queryParameters = {};
                headerParameters = {};
                if (requestParameters['xVisitorId'] != null) {
                    headerParameters['X-Visitor-Id'] = String(requestParameters['xVisitorId']);
                }
                urlPath = "/v1/onboarding/visitors/session";
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'GET',
                        headers: headerParameters,
                        query: queryParameters,
                    }];
            });
        });
    };
    /**
     * Get current visitor session status (including linked/expired)
     */
    OnboardingApi.prototype.onboardingControllerGetVisitorSessionV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.onboardingControllerGetVisitorSessionV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, VisitorSessionResponseDto_1.VisitorSessionResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get current visitor session status (including linked/expired)
     */
    OnboardingApi.prototype.onboardingControllerGetVisitorSessionV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.onboardingControllerGetVisitorSessionV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for onboardingControllerListSportsV1 without sending the request
     */
    OnboardingApi.prototype.onboardingControllerListSportsV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                queryParameters = {};
                headerParameters = {};
                if (requestParameters['acceptLanguage'] != null) {
                    headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
                }
                if (requestParameters['xLanguage'] != null) {
                    headerParameters['X-Language'] = String(requestParameters['xLanguage']);
                }
                urlPath = "/v1/onboarding/sports";
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'GET',
                        headers: headerParameters,
                        query: queryParameters,
                    }];
            });
        });
    };
    /**
     * List active sports for onboarding
     */
    OnboardingApi.prototype.onboardingControllerListSportsV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.onboardingControllerListSportsV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(SportResponseDto_1.SportResponseDtoFromJSON); })];
                }
            });
        });
    };
    /**
     * List active sports for onboarding
     */
    OnboardingApi.prototype.onboardingControllerListSportsV1 = function () {
        return __awaiter(this, arguments, void 0, function (requestParameters, initOverrides) {
            var response;
            if (requestParameters === void 0) { requestParameters = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.onboardingControllerListSportsV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for onboardingControllerPatchMyDigestPreferenceStepV1 without sending the request
     */
    OnboardingApi.prototype.onboardingControllerPatchMyDigestPreferenceStepV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                if (requestParameters['sportCode'] == null) {
                    throw new runtime.RequiredError('sportCode', 'Required parameter "sportCode" was null or undefined when calling onboardingControllerPatchMyDigestPreferenceStepV1().');
                }
                if (requestParameters['stepId'] == null) {
                    throw new runtime.RequiredError('stepId', 'Required parameter "stepId" was null or undefined when calling onboardingControllerPatchMyDigestPreferenceStepV1().');
                }
                if (requestParameters['patchDigestStepDto'] == null) {
                    throw new runtime.RequiredError('patchDigestStepDto', 'Required parameter "patchDigestStepDto" was null or undefined when calling onboardingControllerPatchMyDigestPreferenceStepV1().');
                }
                queryParameters = {};
                headerParameters = {};
                headerParameters['Content-Type'] = 'application/json';
                urlPath = "/v1/onboarding/digest-preferences/me/sports/{sportCode}/steps/{stepId}";
                urlPath = urlPath.replace('{sportCode}', encodeURIComponent(String(requestParameters['sportCode'])));
                urlPath = urlPath.replace('{stepId}', encodeURIComponent(String(requestParameters['stepId'])));
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'PATCH',
                        headers: headerParameters,
                        query: queryParameters,
                        body: (0, PatchDigestStepDto_1.PatchDigestStepDtoToJSON)(requestParameters['patchDigestStepDto']),
                    }];
            });
        });
    };
    /**
     * Replace answers for a single digest preference step
     */
    OnboardingApi.prototype.onboardingControllerPatchMyDigestPreferenceStepV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.onboardingControllerPatchMyDigestPreferenceStepV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, PatchDigestStepResponseDto_1.PatchDigestStepResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Replace answers for a single digest preference step
     */
    OnboardingApi.prototype.onboardingControllerPatchMyDigestPreferenceStepV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.onboardingControllerPatchMyDigestPreferenceStepV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for onboardingControllerPatchMyDigestPreferencesV1 without sending the request
     */
    OnboardingApi.prototype.onboardingControllerPatchMyDigestPreferencesV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                if (requestParameters['patchDigestPreferencesDto'] == null) {
                    throw new runtime.RequiredError('patchDigestPreferencesDto', 'Required parameter "patchDigestPreferencesDto" was null or undefined when calling onboardingControllerPatchMyDigestPreferencesV1().');
                }
                queryParameters = {};
                headerParameters = {};
                headerParameters['Content-Type'] = 'application/json';
                urlPath = "/v1/onboarding/digest-preferences/me";
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'PATCH',
                        headers: headerParameters,
                        query: queryParameters,
                        body: (0, PatchDigestPreferencesDto_1.PatchDigestPreferencesDtoToJSON)(requestParameters['patchDigestPreferencesDto']),
                    }];
            });
        });
    };
    /**
     * Merge sport selection and answers into digest preferences
     */
    OnboardingApi.prototype.onboardingControllerPatchMyDigestPreferencesV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.onboardingControllerPatchMyDigestPreferencesV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, PatchDigestPreferencesResponseDto_1.PatchDigestPreferencesResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Merge sport selection and answers into digest preferences
     */
    OnboardingApi.prototype.onboardingControllerPatchMyDigestPreferencesV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.onboardingControllerPatchMyDigestPreferencesV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for onboardingControllerPatchMyDigestSportVisibilityV1 without sending the request
     */
    OnboardingApi.prototype.onboardingControllerPatchMyDigestSportVisibilityV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                if (requestParameters['sportCode'] == null) {
                    throw new runtime.RequiredError('sportCode', 'Required parameter "sportCode" was null or undefined when calling onboardingControllerPatchMyDigestSportVisibilityV1().');
                }
                if (requestParameters['patchDigestSportVisibilityDto'] == null) {
                    throw new runtime.RequiredError('patchDigestSportVisibilityDto', 'Required parameter "patchDigestSportVisibilityDto" was null or undefined when calling onboardingControllerPatchMyDigestSportVisibilityV1().');
                }
                queryParameters = {};
                headerParameters = {};
                headerParameters['Content-Type'] = 'application/json';
                urlPath = "/v1/onboarding/digest-preferences/me/sports/{sportCode}/visibility";
                urlPath = urlPath.replace('{sportCode}', encodeURIComponent(String(requestParameters['sportCode'])));
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'PATCH',
                        headers: headerParameters,
                        query: queryParameters,
                        body: (0, PatchDigestSportVisibilityDto_1.PatchDigestSportVisibilityDtoToJSON)(requestParameters['patchDigestSportVisibilityDto']),
                    }];
            });
        });
    };
    /**
     * Hide or unhide a sport on the manage digest tab bar
     */
    OnboardingApi.prototype.onboardingControllerPatchMyDigestSportVisibilityV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.onboardingControllerPatchMyDigestSportVisibilityV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, PatchDigestSportVisibilityResponseDto_1.PatchDigestSportVisibilityResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Hide or unhide a sport on the manage digest tab bar
     */
    OnboardingApi.prototype.onboardingControllerPatchMyDigestSportVisibilityV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.onboardingControllerPatchMyDigestSportVisibilityV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for onboardingControllerRemoveMyDigestSportV1 without sending the request
     */
    OnboardingApi.prototype.onboardingControllerRemoveMyDigestSportV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                if (requestParameters['sportCode'] == null) {
                    throw new runtime.RequiredError('sportCode', 'Required parameter "sportCode" was null or undefined when calling onboardingControllerRemoveMyDigestSportV1().');
                }
                queryParameters = {};
                headerParameters = {};
                urlPath = "/v1/onboarding/digest-preferences/me/sports/{sportCode}";
                urlPath = urlPath.replace('{sportCode}', encodeURIComponent(String(requestParameters['sportCode'])));
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'DELETE',
                        headers: headerParameters,
                        query: queryParameters,
                    }];
            });
        });
    };
    /**
     * Remove a sport from digest preferences
     */
    OnboardingApi.prototype.onboardingControllerRemoveMyDigestSportV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.onboardingControllerRemoveMyDigestSportV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, RemoveDigestSportResponseDto_1.RemoveDigestSportResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Remove a sport from digest preferences
     */
    OnboardingApi.prototype.onboardingControllerRemoveMyDigestSportV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.onboardingControllerRemoveMyDigestSportV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for onboardingControllerSubmitDigestPreferencesV1 without sending the request
     */
    OnboardingApi.prototype.onboardingControllerSubmitDigestPreferencesV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                if (requestParameters['xVisitorId'] == null) {
                    throw new runtime.RequiredError('xVisitorId', 'Required parameter "xVisitorId" was null or undefined when calling onboardingControllerSubmitDigestPreferencesV1().');
                }
                if (requestParameters['submitDigestPreferencesDto'] == null) {
                    throw new runtime.RequiredError('submitDigestPreferencesDto', 'Required parameter "submitDigestPreferencesDto" was null or undefined when calling onboardingControllerSubmitDigestPreferencesV1().');
                }
                queryParameters = {};
                headerParameters = {};
                headerParameters['Content-Type'] = 'application/json';
                if (requestParameters['xVisitorId'] != null) {
                    headerParameters['X-Visitor-Id'] = String(requestParameters['xVisitorId']);
                }
                urlPath = "/v1/onboarding/digest-preferences";
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'POST',
                        headers: headerParameters,
                        query: queryParameters,
                        body: (0, SubmitDigestPreferencesDto_1.SubmitDigestPreferencesDtoToJSON)(requestParameters['submitDigestPreferencesDto']),
                    }];
            });
        });
    };
    /**
     * Submit digest preferences for visitor session
     */
    OnboardingApi.prototype.onboardingControllerSubmitDigestPreferencesV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.onboardingControllerSubmitDigestPreferencesV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, SubmitDigestPreferencesResponseDto_1.SubmitDigestPreferencesResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Submit digest preferences for visitor session
     */
    OnboardingApi.prototype.onboardingControllerSubmitDigestPreferencesV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.onboardingControllerSubmitDigestPreferencesV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for onboardingControllerUpdateVisitorStepV1 without sending the request
     */
    OnboardingApi.prototype.onboardingControllerUpdateVisitorStepV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                if (requestParameters['id'] == null) {
                    throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling onboardingControllerUpdateVisitorStepV1().');
                }
                if (requestParameters['xVisitorId'] == null) {
                    throw new runtime.RequiredError('xVisitorId', 'Required parameter "xVisitorId" was null or undefined when calling onboardingControllerUpdateVisitorStepV1().');
                }
                if (requestParameters['updateVisitorStepDto'] == null) {
                    throw new runtime.RequiredError('updateVisitorStepDto', 'Required parameter "updateVisitorStepDto" was null or undefined when calling onboardingControllerUpdateVisitorStepV1().');
                }
                queryParameters = {};
                headerParameters = {};
                headerParameters['Content-Type'] = 'application/json';
                if (requestParameters['xVisitorId'] != null) {
                    headerParameters['X-Visitor-Id'] = String(requestParameters['xVisitorId']);
                }
                urlPath = "/v1/onboarding/visitors/{id}/step";
                urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'PATCH',
                        headers: headerParameters,
                        query: queryParameters,
                        body: (0, UpdateVisitorStepDto_1.UpdateVisitorStepDtoToJSON)(requestParameters['updateVisitorStepDto']),
                    }];
            });
        });
    };
    /**
     * Update onboarding step for visitor session
     */
    OnboardingApi.prototype.onboardingControllerUpdateVisitorStepV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.onboardingControllerUpdateVisitorStepV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Update onboarding step for visitor session
     */
    OnboardingApi.prototype.onboardingControllerUpdateVisitorStepV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.onboardingControllerUpdateVisitorStepV1Raw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return OnboardingApi;
}(runtime.BaseAPI));
exports.OnboardingApi = OnboardingApi;
